import type { ComponentProps } from 'react'

import type { IconProps } from 'components'
import { theme } from 'styles/theme/hav-theme'

export const HC = ({
  color = theme.colors.support.second, // NOTE: Hava Conecta color
  fill = theme.colors.neutral.white,
  width = '26',
  height = '18',
  viewBox = '0 0 26 18',
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect height="17" rx="1.5" stroke={color} width="25" x="0.5" y="0.5" />
      <path
        d="M4.84 13.5V4.86H6.472V8.412H10.336V4.86H11.968V13.5H10.336V9.936H6.472V13.5H4.84ZM17.3605 13.68C16.4965 13.68 15.7505 13.492 15.1225 13.116C14.4985 12.74 14.0165 12.214 13.6765 11.538C13.3405 10.862 13.1725 10.076 13.1725 9.18C13.1725 8.284 13.3405 7.498 13.6765 6.822C14.0165 6.146 14.4985 5.62 15.1225 5.244C15.7505 4.868 16.4965 4.68 17.3605 4.68C18.3525 4.68 19.1845 4.926 19.8565 5.418C20.5325 5.91 21.0085 6.576 21.2845 7.416L19.6405 7.872C19.4805 7.348 19.2105 6.942 18.8305 6.654C18.4505 6.362 17.9605 6.216 17.3605 6.216C16.8125 6.216 16.3545 6.338 15.9865 6.582C15.6225 6.826 15.3485 7.17 15.1645 7.614C14.9805 8.058 14.8885 8.58 14.8885 9.18C14.8885 9.78 14.9805 10.302 15.1645 10.746C15.3485 11.19 15.6225 11.534 15.9865 11.778C16.3545 12.022 16.8125 12.144 17.3605 12.144C17.9605 12.144 18.4505 11.998 18.8305 11.706C19.2105 11.414 19.4805 11.008 19.6405 10.488L21.2845 10.944C21.0085 11.784 20.5325 12.45 19.8565 12.942C19.1845 13.434 18.3525 13.68 17.3605 13.68Z"
        fill={color}
      />
    </svg>
  )
}
